import React, { useEffect, useState } from "react";
import axios from "axios";
import styles from "./reports.module.scss";

import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Images from "assets/Images";
import { APIConstant } from "services/api-constant";
import { useNavigate, useParams } from 'react-router-dom';

const ReportsInterviewDataList = ({ token }) => {
  const { id } = useParams();
  const [interviews, setInterviews] = useState([]);
  const [technology, setTechnology] = useState({});
  const [loading, setLoading] = useState(false);

  const getTechnologies = async () => {
    const res = await axios.get(APIConstant.getTechnologies, {
      headers: { Authorization: `Bearer ${token}` },
    });
    const filtered = res.data.find((tech) => tech.id == id);
   
    setTechnology(filtered)
  }
  useEffect(() => {
    getTechnologies()
  }, []);

  const [value, setValue] = React.useState("1");

  const handleChangeTabs = (event, newValue) => {
    setValue(newValue);
  };

  const headers = {
    Authorization: `Bearer ${token}`,
  };

  const fetchInterviews = async () => {
    try {
      setLoading(true);
    const res = await axios.get(APIConstant.getInterviews, {
      headers,
    });
    const filtered = res.data.filter((interview) => interview.question_id == id);
    setInterviews(filtered);
  } catch (err) {
    console.error("Failed to fetch interviews:", err);
  } finally {
    setLoading(false);
  }
  };



  const handleDelete = async (id) => {
    try {
      await axios.delete(`${APIConstant.getInterviews}/${id}`, {
        headers,
      });
      fetchInterviews();
    } catch (err) {
      console.error("Delete error:", err);
    }
  };

  useEffect(() => {
    fetchInterviews();
  }, []);

  

  const handleClickOpenViewInterview = () => {
    setOpenViewInterview(true);
  };

   const handleOpenMinutesOfMeeting = () => {
    setOpenViewMinutesOfMeeting(true);
  };


  const getCustomerLink = (user, room) => {
    // navigate(`/meeting?user=${user}&room=${room}`);
    setMeetingUrl(`${window.location.protocol}//${window.location.hostname}:${window.location.port}/meeting?user=${user}&room=${room}`)
    setOpenCopyMeetingLink(true)
  }
 

  return (
    <div className={styles.interviewWrapper}>
     

      {/* Interview List */}

      <div className={`bg-white rounded allInterview ${styles.allInterview}`}>
        <TabContext value={value}>
          <TabList
            onChange={handleChangeTabs}
            aria-label="lab API tabs example"
             variant="scrollable"       
            scrollButtons="auto"       
            allowScrollButtonsMobile
          >
            <Tab label="Scheduled EKYC" value="1" />
            <Tab label="Verified" value="3" />
            <Tab label="Rejected" value="4" />
            <Tab label="OnHold" value="5" />
          </TabList>

          <TabPanel value="1">
            {loading ? (
              <div className="flex justify-center items-center h-48">
                <p className={`text-gray-500 text-lg ${styles.gridLoaderContainer}`}>
                  <img src={Images.SPINNER} width="80" alt="Loading..."/>
                </p>
              </div>
            ) : (
              <div className={styles.tableContainer}>
               <table className="w-full text-left border">
              <thead>
                <tr className="bg-gray-100">
                  <th className="p-2" width="200">
                    Interview Name
                  </th>
                  
                  <th className="p-2" width="250">
                    Date & Time
                  </th>
                  <th className="p-2" width="200">
                    Time zone
                  </th>
                  <th className="p-2" width="200">
                    Customer
                  </th>
                  {/* <th className="p-2">Interviewer</th> */}
                  {/* <th className="p-2">Score</th> */}
                  <th className="p-2">Status</th>
                  <th className="p-2" width="100">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {interviews.map((intv) => (
                  <>
                    <tr key={intv.id} className="border-t">
                      <td className="p-2">{intv.interview_name}</td>
                      <td className="p-2">{technology.name}</td>
                      <td className="p-2">{new Date(intv.date_time).toLocaleDateString("en-US", {hour: "2-digit",minute: "2-digit",hour12: true,})}</td>
                      <td className="p-2">{intv.candidate_name} &nbsp; <a style={{ cursor: 'pointer' }} onClick={() => getCustomerLink('customer', intv.room_name)}><img src={Images.LINK} alt="Link" width="14" /></a></td>
                      {/* <td className="p-2">{intv.interviewer_name} &nbsp;  <a style={{ cursor: 'pointer' }} onClick={() => getCustomerLink('interviewer', intv.room_name)}><img src={Images.LINK} alt="Link" width="14" /></a></td> */}
                      {/* <td className="p-2">{intv.score}</td> */}
                      <td className="p-2">{intv.status}</td>
                      <td className="p-2">
                        {/* <button
                                onClick={() => handleDelete(intv.id)}
                                className="text-red-600 hover:underline"
                            >
                                Delete
                            </button> */}

                        <ul className={styles.actionIcons}>
                          <li>
                            <a onClick={handleOpenMinutesOfMeeting} title="Minutes Of Meetings">
                              <img src={Images.MEETINGS} alt="View" width="16" />
                            </a>
                          </li>
                          <li>
                            <a onClick={handleClickOpenViewInterview}>
                              <img src={Images.VIEW} alt="View" width="16" />
                            </a>
                          </li>
                          {/* <li>
                            <a onClick={handleOpenScheduleInterview} title="Schedule Interview">
                              <img src={Images.CALENDAR} alt="View" width="16" />
                            </a>
                          </li> */}
                          <li>
                            <a
                              onClick={() => handleDelete(intv.id)}
                              className="text-red-600 hover:underline"
                            >
                              <img src={Images.TRASH} alt="Delete" width="16" />
                            </a>
                          </li>
                        </ul>
                      </td>
                    </tr>
                    <tr colSpan="6"></tr>
                  </>
                ))}
                {/* */}
              </tbody>
            </table>
            </div>
            )}
          </TabPanel>
          <TabPanel value="1"></TabPanel>
          <TabPanel value="3">Verified</TabPanel>
          <TabPanel value="4">Rejected</TabPanel>
          <TabPanel value="5">On Hold</TabPanel>
        </TabContext>
      </div>
    </div>
  );
};

export default ReportsInterviewDataList;
